import React, { Component, PropTypes } from 'react';
import s from './Phone.scss';

class Phone extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    children: ''
  };

  render() {
    return (
      <div className={s.root}>
        <div className={s.content}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Phone;



// WEBPACK FOOTER //
// ./src/themes/components/Phone/Phone.js